module.exports = __webpack_public_path__ + "img/1.626caa3e.jpg";